window.VegasCatalog = {
	popup: function (text, params = {}, type = 'success') {
		let defaults = {
			"positionClass": "toast-bottom-center",
			'preventDuplicates': true
		};

		Toastr.options = Object.assign(defaults, params);

		if (type === 'success') Toastr.success(text);
		if (type === 'error') Toastr.error(text);
	}
};

require('./_cart');
require('./order/order');
require('./_input-counter');
require('./_product');
require('./_catalog_list');
require('./_promocode_notifier');

// get active swiper slide
document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		let categoryActive = document.querySelector('#swiper-menu-categories .swiper-slide:not(.swiper-slide-duplicate) .category.active');

		if(!categoryActive) {
			return
		}

		let id = categoryActive.closest('.swiper-slide').getAttribute('data-swiper-slide-index');
		let swiper = document.querySelector('#swiper-menu-categories').swiper;
		swiper.slideTo(Number(id));
		swiper.autoplay.stop();

	}, 100);
});
